// import { Validator } from "vee-validate";
import { createHelpers } from "vuex-map-fields";

// moment js for dates
import moment from "moment";

const { mapFields: root_state } = createHelpers({
  getterType: "getRoot"
});

export default {
  data() {
    return {
      current_locale: "en",
      limitarr: [10, 25, 100],
      status: ["Active", "Inactive"]
    };
  },
  methods: {
    setValidationMessage() {
      let dict = {
        custom: {
          email: {
            required: this.$t("validations.enter_email"),
            email: this.$t("validations.enter_valid_email")
          },
          phone: {
            required: this.$t("validations.enter_phone"),
            max: this.$t("validations.phone_validation"),
            min: this.$t("validations.phone_min_validation"),
            regex: this.$t("validations.phone_regex"),
          },
          password: {
            required: this.$t("validations.enter_password"),
            min: this.$t("validations.password_validation")
          },
          confirm_phone: {
            required: this.$t("validations.enter_confirm_password"),
            confirmed: this.$t("validations.confirm_phone_validation")
          },
          password_confirmation: {
            required: this.$t("validations.enter_confirm_password"),
            confirmed: this.$t("validations.confirm_password_validation")
          },
          new_password: {
            required: this.$t("validations.enter_new_password"),
            min: this.$t("validations.password_validation")
          },
          current_password: {
            required: this.$t("validations.enter_current_password")
          },
          token: {
            required: this.$t("validations.enter_token")
          },
          name: {
            required: this.$t("validations.enter_name")
          },
          description: {
            required: this.$t("validations.enter_description")
          },
          how_heard: {
            required: this.$t("validations.select_how_heard")
          },
          test_types: {
            required: this.$t("validations.select_test_types")
          },
          test_kit: {
            required: this.$t("validations.select_test_kit")
          },
          username: {
            required: this.$t("validations.enter_user_name")
          },
          username_email_mobile:{
            required: this.$t("validations.username_email_mobile")
          },
          birth_date: {
            required: this.$t("validations.enter_birth_date")
          },
          zip_code: {
            required: this.$t("validations.enter_zip_code")
          },
          select_state: {
            required: this.$t("validations.select_state")
          },
          first_name: {
            required: this.$t("validations.enter_first_name")
          },
          last_name: {
            required: this.$t("validations.enter_last_name")
          },
          enter_address: {
            required: this.$t("validations.enter_address")
          },
          mailing_city:{
            required: this.$t("validations.enter_mailing_city")
          },
          mailing_county:{
            required: this.$t("validations.enter_mailing_county")
          },
          enter_mailing_address_1:{
            required: this.$t("validations.enter_mailing_address_1")
          },
          enter_mailing_zipcode:{
            required: this.$t("validations.enter_mailing_zipcode")
          },
          enter_mailing_state:{
            required: this.$t("validations.enter_mailing_state")
          },
          enter_mailing_city:{
            required: this.$t("validations.enter_mailing_city")
          },
          enter_mailing_county:{
            required: this.$t("validations.enter_mailing_county")
          },
          select_race: {
            required: this.$t("validations.select_race")
          },
          select_gender: {
            required: this.$t("validations.select_gender")
          },
          select_sex_with: {
            required: this.$t("validations.please_select_all_that_apply")
          },
          select_sex_at_birth: {
            required: this.$t("validations.select_sex_at_birth")
          },
          select_county: {
            required: this.$t("validations.select_county")
          },
          select_city: {
            required: this.$t("validations.select_city")
          },
          test_kits: {
            required: this.$t("validations.select_test_kits")
          },
          select_clinic: {
            required: this.$t("validations.select_clinic")
          },
          attestation: {
            required: this.$t("validations.attestation")
          },
          preferred_contact_method: {
            required: this.$t("validations.select_preferred_contact_method")
          },
          language_preference: {
            required: this.$t("validations.select_language_preference")
          },
          select_hispanic: {
            required: this.$t("validations.select_hispanic")
          },
          select_roles: {
            required: this.$t("validations.select_roles")
          },
          program_code: {
            required: this.$t("validations.program_code")
          },
          select_test_result: {
            required: this.$t("validations.test_result")
          },
          select_permissions: {
            required: this.$t("validations.select_permissions")
          },
          select_disease: {
            required: this.$t("validations.select_disease")
          },
          select_assay_types: {
            required: this.$t("validations.select_assay_types")
          },
          select_specimen_types: {
            required: this.$t("validations.select_specimen_types")
          },
          select_symptoms:{
            required: this.$t("validations.select_symtoms")
          },
          confirm_email: {
            required: this.$t("validations.enter_confirm_email"),
            confirmed: this.$t("validations.confirm_email_validation")

          },
          confirmphone:{
            required: this.$t("validations.enter_confirm_phone"),
            confirmed: this.$t("validations.confirm_phone_validation")
          },
          cost: {
            required: this.$t("validations.enter_cost")
          },
          enter_city: {
            required: this.$t("validations.enter_city")
          },
          code: {
            required: this.$t("validations.enter_code")
          },
          state:{
            required: this.$t("validations.select_state")
          },
          county:{
            required: this.$t("validations.select_county")
          },
          zipcode: {
            required: this.$t("validations.enter_zip_code")
          },
          city:{
            required: this.$t("validations.select_city")
          },
          race:{
            required: this.$t("validations.race")
          },
          gender:{
            required: this.$t("validations.gender")
          },
          hispanic:{
            required: this.$t("validations.hispanic")
          },
          question_1:{
            required: this.$t("validations.question_1")
          },
          question_2:{
            required: this.$t("validations.question_2")
          },
          question_3:{
            required: this.$t("validations.question_3")
          },
          question_4:{
            required: this.$t("validations.question_4")
          },
          question_5:{
            required: this.$t("validations.question_5")
          },
          question_6:{
            required: this.$t("validations.question_6")
          },
          select_end_date:{
            required: this.$t("validations.enter_end_date")
          },
          select_start_date:{
            required: this.$t("validations.enter_start_date")
          },
          select_order_end_date:{
            required: this.$t("validations.enter_end_date")
          },
          select_order_start_date:{
            required: this.$t("validations.enter_start_date")
          },
          result_name_english:{
            required: this.$t("validations.result_name_english")
          },
          test_code: {
            required: this.$t("validations.test_code")
          },
          case_code: {
            required: this.$t("validations.case_code")
          },
          select_lab:{
            required: this.$t("validations.select_lab")
          },
          select_test_end_date:{
            required: this.$t("validations.enter_end_date")
          },
          select_test_start_date:{
            required: this.$t("validations.enter_start_date")
          },
        }
      };
      // Validator.localize("en", dict);
    },
    goBack() {
      history.back();
    },
    isUserType(type) {
      return this.user_info.type === type;
    },
    get_limited_string(str) {
      console.log("test");
      if (str) {
        if (str.length > 30) {
          return str.substring(0, 30) + "..";
        } else {
          return str.substring(0, 30);
        }
      }
      return null;
    },
    exportExcelFile(data, filename) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename + ".csv");
      document.body.appendChild(link);
      link.click();
      return;
    },
    exportExcelFileXLSX(data, filename) {
      const url = window.URL.createObjectURL(new Blob([data], {
        type: "application/octet-stream",
      }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename + ".xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      return;
    },
    exportZipFile(data, filename) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename + ".zip");
      document.body.appendChild(link);
      link.click();
      return;
    },
    exportPdfFile(data, filename) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename + ".pdf");
      document.body.appendChild(link);
      link.click();
      return;
    }
  },
  computed: {
    ...root_state(["user_info"])
  }
};
